import { useSelector } from 'react-redux'

import ChartAttractive from 'Component/graph/attractive'
import SubHead from 'Component/title/sub_head';
import renderingGuide from 'Component/title/guide_content';
const Attractive = () => {

	const { tickerDetail } = useSelector((state) => state.stock);
  
	return (
		<>
			{ tickerDetail && tickerDetail.att &&
				<div className="content3">
					<SubHead guideType="stock" guide="att">
						<img src="/static/images/icon_heart2.svg" alt="" />
						<span>토브스탁 투자매력도</span>
					</SubHead>
								<>
									<div className="cont">
										<ChartAttractive data={tickerDetail.att} title="투자매력도" />
									</div>
								</>
				</div>
			}
		</>
	);
}

export default Attractive;
